<template>
<ion-app main>
  <ion-header>
    <ion-toolbar color="primary">
      <ion-buttons slot="start">
        <ion-button @click="openEnd">
          <ion-icon name="menu"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-title>Agenda</ion-title>
    </ion-toolbar>
    <ion-progress-bar type="indeterminate" v-if="cargando"></ion-progress-bar>
  </ion-header>
  <ion-content color="">
    <ion-searchbar placeholder="Filtrar por equipo o cliente" debounce="1000" :value="queryFiltro" v-on:ionChange="queryFiltro=$event.detail.value"></ion-searchbar>
    <ion-row>
      <ion-col class="ion-no-padding">
        <div class="mycalendar">
          <Calendar :rows="calendarioRows" :columns="calendarioCols" title-position="right" :step="1" :attributes="mapaCitasACalendario" color="indigo" @dayclick="verDia" />
          <ion-row>
            <ion-col class="ion-no-padding">
              <ion-item color="secondary" lines="none">
                <ion-label position="floating">Ver columnas</ion-label>
                <ion-input type="number" min="1" :value="calendarioCols" v-on:ionChange="calendarioCols=$event.detail.value"></ion-input>
              </ion-item>
            </ion-col>
            <ion-col class="ion-no-padding">
              <ion-item color="secondary" lines="none">
                <ion-label position="floating">Ver filas</ion-label>
                <ion-input type="number" min="1" :value="calendarioRows" v-on:ionChange="calendarioRows=$event.detail.value"></ion-input>
              </ion-item>
            </ion-col>
          </ion-row>
        </div>
      </ion-col>
      <ion-col class="ion-no-padding">
        <ion-card>
          <ion-item color="light" lines="none">
            <ion-note slot="start">
              <i class="icon ion-ios-calendar"></i>
            </ion-note>
            <ion-label>{{diaActual | moment('MMM DD')}}</ion-label>
          </ion-item>
          <ion-list v-if="Object.keys(citas).length>0">
            <ion-item-sliding v-for="cita in citas" :key="cita._id">
              <ion-item @click="opciones(cita)">
                <ion-note slot="start" :color="cita.terminada?'success':'medium'">
                  <i class="icon ion-ios-checkmark-circle-outline" v-if="cita.terminada"></i>
                  <i class="icon ion-ios-information-circle-outline" v-else></i>
                </ion-note>
                <ion-label>
                  <h2>{{(cita.fechaProgramada || cita.fecha) | moment('HH:mm')}} <span v-if="cita.cliente">{{cita.cliente.alias || cita.cliente.nombre}}</span></h2>
                  <p v-if="cita.equipo">{{cita.equipo.marca}} {{cita.equipo.modelo}} {{cita.equipo.alias || cita.equipo.nombre}}</p>
                  <p v-if="cita.idAutor!=yo._id && cita.autor">Por {{cita.autor.nombre}}</p>
                  <p v-if="cita.notas">{{cita.notas}}</p>
                </ion-label>
                <ion-note slot="end" v-if="cita.tipo=='cita'" color="light">
                  <i class="icon ion-ios-calendar"></i>
                </ion-note>
                <ion-button v-if="citaNoConfirmada(cita)" slot="end" @click="confirmarCita(cita)">Confirmar</ion-button>
              </ion-item>
            </ion-item-sliding>
          </ion-list>
          <ion-item lines="none" v-else>
            <ion-label color="danger">
              <h2>No hay citas para este día.</h2>
              <p>Aún.</p>
            </ion-label>
          </ion-item>
        </ion-card>
      </ion-col>
    </ion-row>
    <ion-fab horizontal="end" vertical="bottom" slot="fixed">
      <ion-fab-button color="primary" @click="nueva">
        <i class="icon icon-lg ion-ios-add"></i>
      </ion-fab-button>
    </ion-fab>
  </ion-content>
</ion-app>
</template>
<style>
.mycalendar {
  margin-top: 24px;
}
</style>
<script>
import Api from '@/components/Api/Api'
import Calendar from 'v-calendar/lib/components/calendar.umd'
import GuiTools from '@/models/GuiTools'
import DatePicker from 'v-calendar/lib/components/date-picker.umd'
import Vue from 'vue'
const yo = Api.fetchLocal('cmms.yo') || {}
Vue.component('calendar', Calendar)
//Vue.component('date-picker', DatePicker)
export default {
  name: 'Agenda',
  props: {
    msg: String
  },
  components: {
    Calendar,
    //DatePicker
  },
  data() {
    return {
      yo,
      cargando: true,
      cdn: Api.cdn + '/',
      diaActual: new Date().toISOString().substring(0, 10),
      citasTodas: [],
      ordenesTodas: [],
      equiposIndices: {},
      clientesIndices: {},
      usuariosIndices: {},
      citas: {},
      esMovil: Api.esMovil(),
      mapaCitasACalendario: [{
        key: 'Hoy',
        dots: true,
        highlight: true,
        dates: new Date(),
      }],
      calendarioCols: Api.fetchLocal('cmms.agendaCalendarioCols') || 2,
      calendarioRows: Api.fetchLocal('cmms.agendaCalendarioRows') || 2,
      queryFiltro: Api.fetchLocal('cmms.agendaQueryFiltro') || ''
    }
  },
  async mounted() {
    await this.obtenerCatalogos()
    await this.obtenerCitas()
    this.verDia({
      date: this.$options.filters.moment(new Date(), 'YYYY-MM-DD')
    })
  },
  watch: {
    calendarioCols: function(a) {
      Api.saveLocal('cmms.agendaCalendarioCols', a)
    },
    calendarioRows: function(a) {
      Api.saveLocal('cmms.agendaCalendarioRows', a)
    },
    queryFiltro: function(a) {
      Api.saveLocal('cmms.agendaQueryFiltro', a)
      this.verDia({
        date: this.diaActual
      })
    }
  },
  methods: {
    openEnd() {
      Api.$emit('open-menu')
    },
    async obtenerCatalogos() {
      //
      const usuarios = await Api.get('directorio')
      for (let u of usuarios)
        this.usuariosIndices[u._id] = u
      const equipos = await Api.get('equipo')
      for (let e of equipos)
        this.equiposIndices[e._id] = e
      const clientes = await Api.get('cliente')
      for (let c of clientes)
        this.clientesIndices[c._id] = c
      return true
    },
    async obtenerCitas() {
      this.cargando = true
      let vm = this
      let filtrosCitas = []
      const clientesIndices = this.clientesIndices
      const usuariosIndices = this.usuariosIndices
      const equiposIndices = this.equiposIndices
      //
      try {
        if (this.yo.rol != 'administrador')
          filtrosCitas = ['idAutor,eq,' + this.yo._id]
        this.citasTodas = (await Api.find('cita', filtrosCitas, {
            sort: ['fecha,1'],
          }))
          .map(c => {
            c.cliente = clientesIndices[c.idCliente] || {}
            c.autor = usuariosIndices[c.idAutor] || {}
            c.equipo = equiposIndices[c.idEquipo] || {}
            return c
          })
        console.log("citasTodas?", this.citasTodas)
        //
        const haceDosMeses = new Date().getTime() - (1000 * 60 * 60 * 24 * 30)
        let filtrosServicios = ['fecha,gte,' + haceDosMeses]
        if (this.yo.rol != 'administrador')
          filtrosServicios = ['idUsuarioAsignado,eq,' + this.yo._id]
        this.ordenesTodas = (await Api.find('ordenservicio', filtrosServicios, {
            sort: ['fecha,-1'],
          }))
          .map(c => {
            c.cliente = clientesIndices[c.idCliente] || {}
            c.autor = usuariosIndices[c.idAutor] || {}
            c.equipo = equiposIndices[c.idEquipo] || {}
            return c
          })
        console.log("ordenesTodas?", this.ordenesTodas.map(o => o.folio))
      } catch (e) {
        console.error(e)
        toast("Intente de nuevo más tarde")
      }
      this.cargando = false
      this.mapearCitasACalendario()
      await Api.wait(100)
      return Promise.resolve(true)
    },
    mapearCitasACalendario() {
      this.mapaCitasACalendario = this.citasTodas.concat(this.ordenesTodas)
        .map(o => {
          return {
            dates: new Date(o.fechaProgramada || o.fecha),
            bar: {
              style: {
                backgroundColor: 'indigo'
              }
            },
            key: o._id
          }
        })
    },
    ver(id = 0) {
      this.$router.push('/cita/' + id)
    },
    verDia(evt) {
      let dia = evt.date
      console.log("verDia?", evt)
      if (typeof dia != 'string')
        dia = dia.toISOString().substring(0, 10)
      this.diaActual = dia
      let vm = this
      let citas = this.citasTodas
        .map(c => {
          c.tipo = 'cita'
          return c
        })
        .filter(c => {
          return dia == vm.$options.filters.moment(c.fechaProgramada || c.fecha, 'YYYY-MM-DD')
        })
      let ordenes = this.ordenesTodas
        .map(c => {
          c.tipo = 'ordenservicio'
          return c
        })
        .filter(c => {
          return dia == vm.$options.filters.moment(c.fechaProgramada || c.fecha, 'YYYY-MM-DD')
        })
      this.citas = {}
      const queryFiltro = this.queryFiltro.toUpperCase()
      let objs = citas.concat(ordenes)
        .map(o => {
          o.nombreCliente = o.cliente?.nombre
          o.nombreAutor = o.autor?.nombre
          o.nombreEquipo = o.equipo?.nombre + o.equipo?.marca + o.equipo?.modelo + o.equipo?.sn
          o.strBuscable = (o.nombreCliente + o.nombreAutor + o.nombreEquipo).toUpperCase()
          console.log("strBuscable", o.strBuscable, queryFiltro)
          return o
        })
        .filter(o => o.strBuscable.indexOf(queryFiltro) > 0 || queryFiltro == '')
      for (let cita of objs) {
        let label = this.$options.filters.moment(cita.fechaProgramada || cita.fecha, 'YYMMDDHH') + cita.idEquipo
        //console.log("cita label", label,cita)
        this.citas[label] = cita
      }
      console.log("verDia?", dia, this.citas)
      this.$forceUpdate()
    },
    link(str) {
      this.$router.push(str)
    },
    citaNoConfirmada(cita) {
      return typeof cita.confirmada != 'undefined' && cita.confirmada == false
    },
    async confirmarCita(cita) {
      cita.confirmada = true
      cita.fechaConfirmada = new Date().getTime()
      await Api.save('cita', cita)
      toast("Cita confirmada")
    },
    opciones(cita) {
      let vm = this
      console.log("opciones", cita)
      let params = []
      if ((this.yo.rol == 'administrador' || this.yo._id == cita.idAutor) &&
        cita.tipo == 'cita')
        params.push({
          text: 'Ver/editar cita',
          handler: () => {
            vm.ver(cita._id)
          }
        })
      if (cita.tipo == 'cita')
        params.push({
          text: 'Crear Orden de Servicio',
          handler: () => {
            vm.crearOrdenServicio(cita)
          }
        })
      else // if(cita.tipo=='ordenservicio')
        params.push({
          text: 'Ir a Orden de Servicio',
          handler: () => {
            vm.link('/ordenes/' + cita._id)
          }
        })
      params.push({
        text: 'Ver cliente',
        handler: () => {
          vm.link('/catalogos/clientes/' + cita.idCliente)
        }
      })
      params.push({
        text: 'Ver equipo',
        handler: () => {
          window.open('#/catalogos/equipos/' + cita.idEquipo + '/modo/historial', '_blank')
        }
      })
      if (cita.tipo == 'cita' && (this.yo._id == cita.idAutor || this.yo.rol == 'administrador')) {
        params.push({
          text: 'Eliminar',
          handler: async () => {
            if (true == confirm('Desea eliminar esta cita? Esto se puede deshacer')) {
              await Api.delete('cita', cita._id)
              await Api.wait(500)
              vm.obtenerCitas()
            }
          }
        })
      }
      let header = 'Opciones: ' + this.$options.filters.moment(cita.fechaProgramada || cita.fecha, 'MMM DD HH:mm') + ' ' + (cita.cliente || {}).alias
      GuiTools.actionSheet(params, header)
    },
    async crearOrdenServicio(cita) {
      console.log("crearOrdenServicio", cita)
      let orden = JSON.parse(JSON.stringify(cita))
      orden.idCita = orden._id
      delete orden._id
      orden.fechaCreada = new Date().toISOString().substring(0, 10)
      orden.fecha = new Date()
      orden.fechaComenzada = new Date().getTime()
      delete orden.fechaProgramada
      orden.fallaReportada = orden.notas
      orden.terminada = false
      orden.idAutor2 = orden.idAutor
      orden.idAutor = orden.idUsuarioAsignado
      let u = await Api.save('ordenservicio', orden)
      alert("Orden creada. Redirigiendo.")
      await Api.wait(1000)
      this.$router.push('/ordenes/' + u._id)
    },
    nueva() {
      this.ver('0')
    }
  }
}
</script>
